import { useCallback } from 'react';

import { useCreatePalletBulkMutation } from '../api/palletsApi';
import type { CreatePalletBulkRequest, CreatePalletBulkParams, CreatePalletResponse } from '../api/palletsApi';

export interface UseCreatePalletBulkOptions {
  onSuccess?: (data: CreatePalletResponse[]) => void;
  onError?: (error: unknown) => void;
}

export const useCreatePalletBulk = (options?: UseCreatePalletBulkOptions) => {
  const [createPalletBulk, { isLoading, isSuccess, isError, error, data }] = useCreatePalletBulkMutation();

  const handleCreate = useCallback(
    async (params: CreatePalletBulkParams, request: CreatePalletBulkRequest) => {
      try {
        const response = await createPalletBulk({
          ...params,
          ...request
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [createPalletBulk, options]
  );

  return {
    createPalletBulk: handleCreate,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
